import React from "react";
import shallowCompare from "react-addons-shallow-compare";
import radium, { Style } from "radium";
import { connect } from "react-redux";
import moment from "moment";
import { START_DATE } from "react-dates/constants";
import { color, media, zIndex } from "rizzo-next/sass/settings.json";
import Price from "../price";
import Button from "../button";
import DateInput from "../form/dateInput";
import Select from "../form/select";
import DotLoader from "../dotLoader";
import Heading from "../heading";
import MoreLink from "../moreLink";
import { add, subtract, gutter, span } from "../../utils/grid";
import { rgb } from "../../../pois/utils/color";
import DateRange from "../form/daterange";
import listActions from "../../../list/actions";

const styles = {
  form: {
    base: {
      position: "relative",
      width: "100%",
    },
  },

  fieldset: {
    base: {
    },

    notFirst: {
      [`@media (max-width: ${media.max["768"]})`]: {
        marginTop: "2rem",
      },

      [`@media (min-width: ${media.min["768"]})`]: {
        marginTop: "1.6rem",
      },
    },

    size: {
      small: {
        [`@media (min-width: ${media.min["768"]})`]: {
          width: subtract([span("1 of 3"), gutter("fluid", 3)]),
        },
      },
      medium: {
        [`@media (min-width: ${media.min["768"]})`]: {
          width: add([span("1 of 3"), gutter("fluid", 3)]),
        },
      },
      large: {
        [`@media (min-width: ${media.min["768"]})`]: {
          width: add([span("2 of 3"), gutter("fluid", 3), gutter("fluid", 3, 0.5)]),
        },
      },
      full: {
        width: "100%",
      },
    },
  },

  button: {
    base: {
      marginTop: "20px",
    },
  },

  loader: {
    base: {
      alignItems: "center",
      backgroundColor: `rgba(${rgb(color.white)}, 1)`,
      display: "flex",
      height: "100%",
      justifyContent: "center",
      marginTop: "20px",
      position: "absolute",
      textAlign: "center",
      width: "100%",
      zIndex: zIndex.slideshowSlide,
    },
  },

  errorMessage: {
    string: {
      color: color.red,
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: 1,
    },

    link: {
      lineHeight: 1,
      marginBottom: "16px",
      marginTop: "5px",
    },
  },
};

export default class Booking extends React.Component {
  static _numNights(startDate, endDate) {
    return (startDate && endDate) ?
      endDate.diff(startDate, "days").toString() :
      "";
  }
  constructor(props) {
    super(props);

    this.setDates = this.setDates.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  componentDidMount() {
    const { startDate, endDate } = this.props;

    const previousDates = {
      startDate,
      endDate,
      numNights: Booking._numNights(startDate, endDate),
    };

    if (this.props.getPriceOnLoad) {
      this._triggerDateChange(Object.assign({}, previousDates));
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  onFocusChange(focused) {
    this.props.dispatch(listActions.showPrices(focused));
  }

  setDates(dates) {
    const newState = {
      startDate: dates.startDate,
      endDate: dates.endDate,
      numNights: Booking._numNights(dates.startDate, dates.endDate),
    };

    this._triggerDateChange(newState);
  }

  _triggerDateChange(newState) {
    if (this.props.onSelectDates) {
      this.props.onSelectDates({
        startDate: newState.startDate && newState.startDate.format("YYYY-MM-DD"),
        endDate: newState.endDate && newState.endDate.format("YYYY-MM-DD"),
        numNights: newState.numNights,
      });
    }
  }

  render() {
    const {
      type,
      message,
      price,
      filter,
      removeBorders,
      url,
      onSubmit,
      buttonLabel,
      withFullScreenPortal,
      focusedInput,
      searching,
      soldOut,
    } = this.props;

    const { startDate, endDate } = this.props;
    const self = this;

    const peopleOptions = [
      "1 guest",
      "2 guests",
      "3 guests",
      "4 guests",
      "5 guests",
      "6 guests",
      "7 guests",
      "8 guests",
      "9 guests",
      "10+ guests",
    ];

    const FieldLayout = {
      activity: (
        <div className="Booking-fieldLayout clearfix">
          {// <fieldset
          //   className="Booking-fieldset"
          //   style={styles.fieldset.base}
          // >
          //   <DateInput
          //     id="activityDate"
          //     format="ddd MMM D"
          //     size="huge"
          //     placeholder="Travel on"
          //     label="Travel on"
          //     startDate={moment()}
          //     noBorder={removeBorders}
          //     required
          //     fill
          //   />
          // </fieldset>
          //
          // <fieldset
          //   className="Booking-fieldset"
          //   style={[styles.fieldset.base, styles.fieldset.notFirst]}
          // >
          //   <Select
          //     id="activityPeople"
          //     defaultValue="2 Guests"
          //     options={peopleOptions}
          //     size="huge"
          //     label="People"
          //     noBorder={removeBorders}
          //     required
          //   />
          // </fieldset>
        }
        </div>
      ),

      hotel: (
        <div className="Booking-fieldLayout clearfix" style={{ position: "relative" }}>
          <fieldset
            className="Booking-fieldset"
            style={styles.fieldset.base}
          >
            <DateRange
              id="hotelDate"
              numberOfMonths={1}
              startDatePlaceholderText="Check-in"
              endDatePlaceholderText="Check-out"
              startDate={startDate}
              endDate={endDate}
              onDatesChange={this.setDates}
              noBorder={removeBorders}
              withFullScreenPortal={withFullScreenPortal}
              focusedInput={focusedInput}
              onFocusChange={this.onFocusChange}
              soldOut={soldOut}
            />
          </fieldset>
          {false &&
            <fieldset
              className="Booking-fieldset"
              style={[styles.fieldset.base, styles.fieldset.notFirst]}
            >
              <Select
                id="hotelGuests"
                defaultValue="2 Guests"
                options={peopleOptions}
                size="huge"
                label="Guests"
                noBorder={removeBorders}
                required
              />
            </fieldset>
          }

          {false &&
            <fieldset
              className="Booking-fieldset"
              style={[styles.fieldset.base, styles.fieldset.notFirst]}
            >
              <Select
                id="hotelGuests"
                defaultValue="2 Guests"
                options={peopleOptions}
                size="huge"
                label="Guests"
                noBorder={removeBorders}
                required
              />
            </fieldset>
          }
        </div>
      ),

      restaurant: (
        <div className="Booking-fieldLayout clearfix">
          <fieldset
            className="Booking-fieldset"
            style={styles.fieldset.base}
          >
            <DateInput
              id="restaurantDay"
              monthFormat="ddd MMM D"
              size="huge"
              placeholder="Day"
              label={["Day", "Time"]}
              startDate={moment()}
              noBorder={removeBorders}
              defaultTime="7:00 PM"
              timeOptions="openTable"
              required
              time
              fill
            />
          </fieldset>

          <fieldset
            className="Booking-fieldset"
            style={[styles.fieldset.base, styles.fieldset.notFirst]}
          >
            <Select
              id="restaurantPeople"
              defaultValue="2 Guests"
              options={peopleOptions}
              size="huge"
              label="Guests"
              noBorder={removeBorders}
              required
            />
          </fieldset>
        </div>
      ),
    };

    const buttonClick = {
      activity(e) {
        e.preventDefault();

        if (onSubmit) {
          onSubmit();
        }

        window.location = url;
      },
      hotel(e) {
        e.preventDefault();

        if (onSubmit) {
          onSubmit({
            startDate: self.props.startDate && self.props.startDate.format("YYYY-MM-DD"),
            endDate: self.props.endDate && self.props.endDate.format("YYYY-MM-DD"),
            numNights: self.props.numNights && self.props.numNights,
          });
        }
      },
      restaurant: null,
    };

    const labels = {
      activity: "Check prices and availability",
      hotel: "Reserve",
      restaurant: "Find a table",
    };

    const noPriceHeading = (price && typeof price.amount !== "undefined" && price.amount === 0) &&
      (message && message.type === "heading" && message.string);

    const noPriceErrorMessage = (price && typeof price.amount !== "undefined" && price.amount === 0) &&
      (message && message.type === "error" && message.string);

    const hasMessageLink = message &&
      message.link &&
      message.link.place &&
      message.link.type &&
      message.link.url;

    return (
      <div className="Booking">
        <Style
          scopeSelector=".Booking"
          rules={{
            ".Price": {
              marginBottom: "12px",
            },
          }}
        />
        {noPriceHeading &&
          <Heading
            level={4}
            weight="thick"
            importance="normal"
            size="small"
            override={{
              marginBottom: "17px",
            }}
            caps
          >
            {message.string}
          </Heading>
        }

        {(noPriceErrorMessage && soldOut) &&
          <div className="Booking-message">
            <div
              style={[
                styles.errorMessage.string,
                !hasMessageLink && { marginBottom: "17px" },
              ]}
            >
              {message.string}
            </div>

            {hasMessageLink &&
              <div style={styles.errorMessage.link}>
                <MoreLink href={message.link.url}>
                  Available {message.link.type} in {message.link.place}
                </MoreLink>
              </div>
            }
          </div>
        }

        {price && price.amount > 0 &&
          <div className="Booking-price">
            <Price
              amount={price.amount}
              currency={price.currency}
              rate={price.rate}
              parent="booking"
              emphasized
            />
          </div>
        }

        <form
          className="Booking-form clearfix"
          style={[
            styles.form.base,
          ]}
        >
          {searching &&
            <div style={styles.loader.base}>
              <DotLoader inline />
            </div>
          }

          {FieldLayout[type]}

          {!filter &&
            <div
              className="Booking-button"
              style={styles.button.base}
            >
              <Button
                onClick={buttonClick[type]}
                full
              >
                {buttonLabel || labels[type]}
              </Button>
            </div>
          }
        </form>
      </div>
    );
  }
}

Booking.propTypes = {
  /**
   * Type of thing to be booked
   */
  type: React.PropTypes.oneOf([
    "activity",
    "hotel",
    "restaurant",
  ]),

  /**
   * Message to show when sold out
   */
  message: React.PropTypes.shape({
    string: React.PropTypes.string,
    type: React.PropTypes.oneOf([
      "heading",
      "error",
    ]),
    link: React.PropTypes.shape({
      place: React.PropTypes.string,
      type: React.PropTypes.string,
      url: React.PropTypes.string,
    }),
  }),

  /**
   * Price of thing to be booked
   */
  price: React.PropTypes.shape({
    amount: React.PropTypes.number,
    currency: React.PropTypes.string,
    rate: React.PropTypes.string,
  }),

  /**
   * Should the form be used on a list page to filter; no submit button
   */
  filter: React.PropTypes.bool,

  /**
   * Whether or not borders should be removed from inputs
   */
  removeBorders: React.PropTypes.bool,

  /**
   * Booking url to send to external resource
   */
  url: React.PropTypes.string,

  onSubmit: React.PropTypes.func,

  onSelectDates: React.PropTypes.func,

  buttonLabel: React.PropTypes.string,

  /**
   * Should the date range component open with the full screen portal
   */
  withFullScreenPortal: React.PropTypes.bool,

  startDate: React.PropTypes.string,

  endDate: React.PropTypes.string,

  getPriceOnLoad: React.PropTypes.bool,

  focusedInput: React.PropTypes.oneOfType([
    React.PropTypes.bool,
    React.PropTypes.string,
  ]),

  dispatch: React.PropTypes.func,

  searching: React.PropTypes.bool,

  soldOut: React.PropTypes.bool,
};

Booking.defaultProps = {
  type: "",

  message: null,

  price: null,

  filter: false,

  removeBorders: false,

  url: "",

  buttonLabel: "",

  withFullScreenPortal: false,

  getPriceOnLoad: false,

  searching: false,

  soldOut: false,
};

Booking.styles = styles;

const mapStateToProps = (state) => ({
  showPrices: state.availability.showPrices,
  focusedInput: state.availability.showPrices === true ?
    START_DATE :
    state.availability.showPrices,
  startDate: state.availability.startDate && moment(state.availability.startDate),
  endDate: state.availability.endDate && moment(state.availability.endDate),
});

const connected = connect(mapStateToProps)(radium(Booking));
export { connected };



// WEBPACK FOOTER //
// ./assets/pois/components/booking/index.jsx